// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"314":"5f26d808","736":"88156d3e"}[chunkId] + ".css";
};